/*
 * cu-pdp.js: gedrag van de productpagina's (template product.cadeau voor pakketten, template product voor losse
 * producten; daar volgen prijs, melding en totaal de gekozen variant via [data-cu-swap]).
 * Geen dependencies, geladen met defer vanuit snippets/cu-pdp.liquid (part 'assets').
 * Progressive enhancement: zonder dit bestand werken prijs, minimum (inline script + min-attribuut),
 * het verplichte 18+-vinkje (required + form=, gezet door het inline script) en de volledige inhoud gewoon.
 * Idempotent: window.cuPdp en data-cu-klaar voorkomen dubbel initialiseren
 * (DOMContentLoaded, page:loaded van het thema en shopify:section:load in de editor).
 * Btw-stand: html[data-cu-btw] (excl = Zakelijk, standaard; incl = Particulier), gezet door snippet
 * cu-prijzen-stand in de head en bewaard in localStorage (cu_prijzen). Dit bestand volgt de stand voor het live
 * totaal en de sticky balk (event cu:btw). Overal één bedrag; de CSS toont .cu-als-excl of .cu-als-incl.
 * Offerteformulier (snippets/cu-pdp-offerte.liquid): aantal vooraf invullen bij openen, leverdatum begrenzen,
 * meten (cu_quote_open, cu_quote_submit, cu_quote_sent), de spamcontrole van Shopify vooraf binden, dubbel
 * verzenden tegengaan, na verzenden contact_posted uit de url halen (herladen geeft dan een leeg formulier en telt
 * niet opnieuw) en na een terugverwijzing van de spamcontrole (?form_type=contact&form_key=) het formulier openen.
 * Minimumbedrag (cu_winkelinfo.bestel_drempel): de melding onder de koopknop volgt aantal x prijs.
 */
(function () {
  'use strict';
  if (window.cuPdp) return;
  window.cuPdp = { version: '1.8.0' };

  var TZ = 'Europe/Amsterdam';
  var BTW_KEY = 'cu_prijzen';

  function track(name, detail) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, detail || {});
      }
    } catch (e) { /* meten mag nooit de pagina breken */ }
    try {
      if (typeof window.clarity === 'function') window.clarity('event', name);
    } catch (e) { /* idem */ }
  }

  function decode(str) {
    var t = document.createElement('textarea');
    t.innerHTML = str || '';
    return t.value;
  }

  /* Geldformaat van het thema: theme.settings (js-variables) en theme.Currency.formatMoney als die er zijn. */
  function themeFormat(fallback) {
    var s = window.theme && window.theme.settings;
    if (s && (s.moneyFormat || s.moneyWithCurrencyFormat)) {
      return s.currencyCodeEnabled ? (s.moneyWithCurrencyFormat || s.moneyFormat) : (s.moneyFormat || s.moneyWithCurrencyFormat);
    }
    return decode(fallback || '');
  }

  function ownFormat(cents, fmt) {
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    }
    function num(value, decimals, thousands, decimal) {
      var parts = (value / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
    }
    var out;
    switch (m[1]) {
      case 'amount': out = num(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': out = num(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = num(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': out = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': out = num(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': out = num(cents, 2, "'", '.'); break;
      default: out = num(cents, 2, '.', ',');
    }
    return fmt.replace(m[0], out);
  }

  function plain(html) {
    return decode(String(html || '').replace(/<[^>]*>/g, ''));
  }

  function formatMoney(cents, fallbackFormat) {
    cents = Math.round(cents);
    var fmt = themeFormat(fallbackFormat);
    try {
      if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function' && fmt) {
        return plain(window.theme.Currency.formatMoney(cents, fmt));
      }
    } catch (e) { /* val terug op het eigen formaat */ }
    return plain(ownFormat(cents, fmt));
  }

  function todayAms() {
    return new Intl.DateTimeFormat('sv-SE', { timeZone: TZ }).format(new Date()); // JJJJ-MM-DD
  }

  /* Btw-stand: html[data-cu-btw] (gezet door het inline script bij de prijs), anders de standaard van het blok. */
  function btwMode(el) {
    var m = document.documentElement.getAttribute('data-cu-btw');
    return m === 'incl' ? 'incl' : 'excl';
  }

  function syncBtwKnoppen() {
    var m = btwMode(null);
    Array.prototype.forEach.call(document.querySelectorAll('[data-cu-btw-knop]'), function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-cu-btw-knop') === m));
    });
  }

  function setBtwMode(m, opslaan) {
    if (m !== 'excl' && m !== 'incl') return;
    document.documentElement.setAttribute('data-cu-btw', m);
    if (opslaan) {
      try { window.localStorage.setItem(BTW_KEY, m); } catch (e) { /* geen opslag: de keuze geldt alleen voor deze pagina */ }
    }
    syncBtwKnoppen();
    try {
      document.dispatchEvent(new CustomEvent('cu:btw', { detail: { mode: m } }));
    } catch (e) { /* oude browser: totaal wordt bij de volgende wijziging bijgewerkt */ }
  }

  /* form.id geeft op het productformulier het veld <input name="id"> terug (benoemde velden gaan voor
     op eigenschappen van het formulier). Daarom overal het id-attribuut lezen, zoals ProductForm van het thema. */
  function formId(form) {
    return (form && typeof form.getAttribute === 'function' && form.getAttribute('id')) || '';
  }

  function esc(value) {
    return (window.CSS && typeof window.CSS.escape === 'function') ? window.CSS.escape(value) : String(value).replace(/["\\]/g, '\\$&');
  }

  function sectionOf(el) {
    return (el && el.closest && el.closest('.shopify-section')) || document;
  }

  function findForm(el, formId) {
    var form = formId ? document.getElementById(formId) : null;
    if (form && form.tagName === 'FORM') return form;
    var sec = sectionOf(el);
    return sec.querySelector('form[id^="ProductForm-"][data-type="add-to-cart-form"]') || sec.querySelector('form[id^="ProductForm-"]');
  }

  function findQty(el, qtyId, form) {
    var input = qtyId ? document.getElementById(qtyId) : null;
    if (input) return input;
    var sec = sectionOf(el);
    var fid = formId(form);
    if (fid) {
      input = sec.querySelector('input[name="quantity"][form="' + esc(fid) + '"]') || form.querySelector('input[name="quantity"]');
    }
    return input || sec.querySelector('input[name="quantity"]');
  }

  function submitters(form) {
    var list = Array.prototype.slice.call(form.querySelectorAll('[type="submit"]'));
    var fid = formId(form);
    if (fid) {
      Array.prototype.forEach.call(document.querySelectorAll('[type="submit"][form="' + esc(fid) + '"]'), function (b) {
        if (list.indexOf(b) < 0) list.push(b);
      });
    }
    return list;
  }

  function guardForm(form) {
    if (!form || form.hasAttribute('data-cu-guard')) return;
    form.setAttribute('data-cu-guard', '');
    form.noValidate = false;
    // Vangnet voor als het thema ooit novalidate of een AJAX-route gebruikt; de sticky knop (form=) valt hier ook onder.
    form.addEventListener('submit', function (e) {
      if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (typeof form.reportValidity === 'function') form.reportValidity();
      }
    }, true);
  }

  function reformatMoney(root) {
    if (!(window.theme && window.theme.settings)) return;
    Array.prototype.forEach.call(root.querySelectorAll('[data-cu-money]'), function (el) {
      var cents = parseInt(el.getAttribute('data-cu-money'), 10);
      if (!isNaN(cents) && cents > 0) el.textContent = formatMoney(cents, '');
    });
  }

  function initAantal(box) {
    if (box.hasAttribute('data-cu-klaar')) return;
    box.setAttribute('data-cu-klaar', '');
    var form = findForm(box, box.getAttribute('data-form'));
    var input = findQty(box, box.getAttribute('data-qty'), form);
    if (!input) return;
    guardForm(form);

    var minBase = parseInt(box.getAttribute('data-min'), 10) || 1;
    // Zoals het thema bij quantity rules: staat het minimum al in de winkelwagen, dan mag je aanvullen.
    var cartQty = parseInt(input.getAttribute('data-cart-quantity'), 10) || 0;
    var min = (minBase > 1 && cartQty >= minBase) ? 1 : minBase;
    var unit = parseInt(box.getAttribute('data-unit'), 10) || 0;
    var excl = parseInt(box.getAttribute('data-excl'), 10) || 0;
    var incl = box.hasAttribute('data-incl') ? box.getAttribute('data-incl') : 'incl. btw';
    var fmt = box.getAttribute('data-money-format') || '';
    var een = box.getAttribute('data-een') || 'stuk';
    var meer = box.getAttribute('data-meer') || 'stuks';
    var totaal = box.querySelector('[data-cu-totaal]');
    var presetsWrap = box.querySelector('[data-cu-presets]');
    // Offerte staat in een eigen block (cu_offerte): zoeken op product-id. Alleen de externe offerteknop krijgt ?product=&aantal=.
    var qbox = document.querySelector('[data-cu-quote][data-product-id="' + (box.getAttribute('data-product-id') || '') + '"]');
    var quote = qbox ? qbox.querySelector(':scope > a[href]') : null;
    var nudge = qbox ? qbox.querySelector('[data-cu-nudge]') : null;
    var nudgeAt = nudge ? (parseInt(nudge.getAttribute('data-at'), 10) || 0) : 0;
    var nudgeShown = false;
    var presetButtons = [];
    // Minimumbedrag per bestelling (alleen als cu_winkelinfo.bestel_drempel gevuld is): melding volgt aantal x prijs.
    var drempelEl = box.querySelector('[data-cu-drempel]');
    var drempel = drempelEl ? (parseInt(drempelEl.getAttribute('data-cu-drempel'), 10) || 0) : 0;
    var minMsg = 'Dit product bestel je vanaf ' + min + ' ' + meer + '.';
    var emptyMsg = 'Vul een aantal in.';
    var totaalTimer = null;

    var minEl = document.getElementById('cu-min-' + (box.getAttribute('data-product-id') || ''));
    if (minEl) {
      var ids = (input.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
      if (ids.indexOf(minEl.id) < 0) {
        ids.push(minEl.id);
        input.setAttribute('aria-describedby', ids.join(' '));
      }
    }

    if (min > 1) {
      input.min = String(min);
      input.setAttribute('data-min', String(min));
      if ((parseInt(input.value, 10) || 0) < min) input.value = String(min);
      var qi = input.closest('quantity-input');
      if (qi && typeof qi.validateQtyRules === 'function') {
        try { qi.validateQtyRules(); } catch (e) { /* thema-API kan wijzigen */ }
      }
    }
    input.setAttribute('inputmode', 'numeric');

    function qty() {
      var q = parseInt(input.value, 10);
      return isNaN(q) ? 0 : q;
    }

    function validate() {
      var q = qty();
      input.setCustomValidity(q <= 0 ? emptyMsg : (q < min ? minMsg : ''));
    }

    // Staffelkorting (snippet cu-staffel, data-treden): het percentage van de hoogste trede die dit aantal haalt.
    // Alleen dit product; mixen met andere producten uit de groep kan in de winkelwagen meer opleveren.
    function staffelBlok() {
      return (box.closest('.shopify-section') || document).querySelector('[data-cu-staffel][data-treden]');
    }
    function staffelPct(q) {
      var sb = staffelBlok();
      if (!sb) return 0;
      var t;
      try { t = JSON.parse(sb.getAttribute('data-treden')); } catch (e) { return 0; }
      var p = 0;
      (t || []).forEach(function (x) { if (q >= x.vanaf) p = x.procent; });
      return p;
    }

    // fromTyping: bij typen de tekst in de live-regio even uitstellen, zodat '100' niet drie meldingen geeft.
    function update(fromTyping) {
      var q = qty();
      validate();
      if (totaal) {
        var tekst = '';
        if (q > Math.max(min, 1)) {
          // Zoals de kassa: korting op het bedrag incl. btw, excl. afgeleid met de verhouding van het product.
          var pct = staffelPct(q);
          var inclTot = Math.round(unit * q * (100 - pct) / 100);
          var inclTxt = formatMoney(inclTot, fmt) + (incl ? ' ' + incl : '');
          if (excl) {
            var sbb = staffelBlok();
            var btwPct = sbb ? parseFloat(sbb.getAttribute('data-btw')) : NaN;
            var exclTot = btwPct > 0 ? Math.round(inclTot / (1 + btwPct / 100)) : Math.round(inclTot * excl / unit);
            var exclTxt = formatMoney(exclTot, fmt) + ' excl. btw';
            // Eén bedrag, volgens de knop Particulier | Zakelijk.
            tekst = btwMode(box) === 'excl' ? exclTxt : inclTxt;
          } else {
            tekst = inclTxt;
          }
          tekst = 'Totaal ' + q + ' ' + (q === 1 ? een : meer) + ': ' + tekst + (pct ? ', met ' + pct + '% staffelkorting' : '');
        }
        if (totaalTimer) { window.clearTimeout(totaalTimer); totaalTimer = null; }
        if (fromTyping === true) {
          totaalTimer = window.setTimeout(function () { totaal.textContent = tekst; }, 400);
        } else {
          totaal.textContent = tekst;
        }
      }
      if (drempelEl && drempel > 0 && unit > 0) {
        drempelEl.hidden = unit * Math.max(q, min) >= drempel;
      }
      if (nudge) {
        var show = nudgeAt > 0 && q >= nudgeAt;
        nudge.hidden = !show;
        if (show && !nudgeShown) { nudgeShown = true; track('cu_quote_nudge_shown', { qty: q }); }
      }
      if (quote) {
        try {
          var base = quote.getAttribute('data-cu-base') || quote.getAttribute('href');
          quote.setAttribute('data-cu-base', base);
          var u = new URL(base, window.location.origin);
          u.searchParams.set('product', box.getAttribute('data-handle') || '');
          u.searchParams.set('aantal', String(Math.max(q, min)));
          quote.setAttribute('href', u.origin === window.location.origin ? u.pathname + u.search + u.hash : u.toString());
        } catch (e) { /* ongeldige URL: laat de link zoals hij is */ }
      }
      presetButtons.forEach(function (b) {
        b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-qty'), 10) === q));
      });
    }

    var presets = (box.getAttribute('data-presets') || '').split(',')
      .map(function (s) { return parseInt(s, 10); })
      .filter(function (n, i, arr) { return n > 0 && n >= min && arr.indexOf(n) === i; });
    if (presetsWrap && presets.length) {
      presets.forEach(function (n) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cu-preset';
        b.textContent = String(n);
        b.setAttribute('data-qty', String(n));
        b.setAttribute('aria-pressed', 'false');
        b.setAttribute('aria-label', n + ' ' + meer);
        b.addEventListener('click', function () {
          input.value = String(n);
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
          track('cu_preset_click', { qty: n });
        });
        presetsWrap.appendChild(b);
        presetButtons.push(b);
      });
      presetsWrap.hidden = false;
    }

    input.addEventListener('input', function () { update(true); });
    document.addEventListener('cu:btw', function () { update(); });
    // Variantkeuze op template product: nieuwe prijs per stuk (en excl.) zonder opnieuw te binden.
    box.__cuPrijs = function (u, e) {
      unit = u > 0 ? u : unit;
      excl = e > 0 ? e : 0;
      update();
    };
    input.addEventListener('change', function () { update(); track('cu_qty_change', { qty: qty() }); });
    input.addEventListener('invalid', function () {
      validate();
      var q = qty();
      if (q > 0 && q < min) track('cu_min_blocked', { qty: q, min: min });
    });
    var qiEl = input.closest('quantity-input');
    if (qiEl) {
      qiEl.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('button')) window.requestAnimationFrame(update);
      });
    }
    update();

    if (min > 1) {
      var sticky = sectionOf(box).querySelector('product-sticky-form') || document.querySelector('product-sticky-form');
      if (sticky && !sticky.querySelector('.cu-sticky-min')) {
        var s = document.createElement('span');
        s.className = 'cu-sticky-min text-sm';
        s.textContent = 'minimaal ' + min + ' stuks';
        var anchor = sticky.querySelector('.price') || sticky.querySelector('[class*="price"]');
        if (anchor) anchor.insertAdjacentElement('afterend', s); else sticky.appendChild(s);
      }
    }
  }

  /* Sticky balk van het thema: eigen prijs in beide btw-standen vóór de themaprijs; de CSS verbergt de themaprijs.
     De balk is onzichtbaar tot je voorbij de koopknop scrolt, dus dit gebeurt ruim voordat hij in beeld komt. */
  function initSticky(box) {
    var excl = parseInt(box.getAttribute('data-excl'), 10) || 0;
    var unit = parseInt(box.getAttribute('data-unit'), 10) || 0;
    if (!excl || !unit || excl >= unit) return;
    var fmt = box.getAttribute('data-money-format') || '';
    var sticky = sectionOf(box).querySelector('product-sticky-form') || document.querySelector('product-sticky-form');
    if (!sticky) return;
    var wrap = sticky.querySelector('[id^="StickyPrice-"]') || sticky;
    var themePrice = wrap.querySelector('.price');
    if (!themePrice || wrap.querySelector('.cu-sticky-prijs')) return;
    function deel(klasse, bedrag, label) {
      var s = document.createElement('span');
      s.className = klasse;
      var g = document.createElement('span');
      g.className = 'price__regular whitespace-nowrap';
      g.textContent = formatMoney(bedrag, fmt);
      s.appendChild(g);
      s.appendChild(document.createTextNode(' ' + label));
      return s;
    }
    var el = document.createElement('span');
    el.className = 'cu-sticky-prijs';
    el.appendChild(deel('cu-als-incl', unit, 'incl. btw'));
    el.appendChild(deel('cu-als-excl', excl, 'excl. btw'));
    themePrice.parentNode.insertBefore(el, themePrice);
  }

  /* Eigen offerteformulier (details/summary): werkt zonder JS; dit vult bij openen het gekozen aantal in,
     begrenst de leverdatum op vandaag en meet. Een formulier dat na verzenden of met fouten open terugkomt,
     telt niet als nieuwe opening. */
  function initQuote(det) {
    if (det.hasAttribute('data-cu-klaar')) return;
    det.setAttribute('data-cu-klaar', '');
    var box = det.closest('[data-cu-quote]') || det;
    var form = det.querySelector('form');
    var qtyField = det.querySelector('[data-cu-quote-qty]');
    var dateField = det.querySelector('[data-cu-quote-date]');
    var min = parseInt(box.getAttribute('data-min'), 10) || 1;
    var handle = box.getAttribute('data-handle') || '';
    var meer = box.getAttribute('data-meer') || 'stuks';
    var terug = det.open; // server-side open: na verzenden of bij fouten
    var gemeten = terug;

    // Spamcontrole van Shopify (hCaptcha). Shopify bindt die pas bij de eerste focus of wijziging in het formulier en
    // gooit tot dan elke verzending weg; na het binden verstuurt de controle zelf (form.submit, zonder submit-event).
    function captchaAan() {
      return !!(window.Shopify && window.Shopify.captcha);
    }
    function captchaGebonden() {
      return !!form && (form.hasAttribute('data-hcaptcha-bound') || form.hasAttribute('data-recaptcha-bound'));
    }
    // Vooraf binden bij openen, zodat de eerste echte klik telt (ook bij een vooringevuld formulier). Pas nadat de
    // eigen submit-listener hieronder staat, zodat het slot vóór de listener van de spamcontrole draait.
    function bindCaptcha() {
      if (!form || !form.querySelector('[type="submit"]') || !captchaAan() || captchaGebonden() || form.hasAttribute('data-cptcha')) return;
      var c = window.Shopify.captcha;
      if (typeof c.protect !== 'function') return;
      try { c.protect(form); } catch (x) { /* dan bindt Shopify zelf bij de eerste focus */ }
    }

    function valQty() {
      if (!qtyField) return;
      var q = parseInt(qtyField.value, 10);
      qtyField.setCustomValidity(qtyField.value !== '' && !isNaN(q) && q < min ? 'Een offerte vraag je aan vanaf ' + min + ' ' + meer + '.' : '');
    }
    if (qtyField) {
      qtyField.addEventListener('input', function () { qtyField.setAttribute('data-cu-touched', ''); valQty(); });
      valQty();
    }
    if (dateField) {
      var t = todayAms();
      var mx = dateField.getAttribute('max');
      var mn = dateField.getAttribute('min');
      if (mx && t > mx) {
        // Levervenster voorbij: geen kiesbare datum meer, dan het veld niet tonen.
        dateField.disabled = true;
        var fld = dateField.closest('[data-cu-quote-date-field]');
        if (fld) fld.hidden = true;
      } else if (!mn || t > mn) {
        dateField.setAttribute('min', t);
      }
    }
    function prefill() {
      if (!qtyField || qtyField.hasAttribute('data-cu-touched')) return;
      var pform = findForm(box, box.getAttribute('data-form'));
      var input = findQty(box, box.getAttribute('data-qty'), pform);
      var q = input ? (parseInt(input.value, 10) || 0) : 0;
      qtyField.value = String(Math.max(q, min));
      valQty();
    }
    det.addEventListener('toggle', function () {
      if (!det.open) return;
      bindCaptcha();
      if (!terug) prefill();
      if (!gemeten) {
        gemeten = true;
        track('cu_quote_open', { product: handle });
      }
    });
    if (form) {
      // Geen dubbele aanvraag bij een dubbelklik of traag netwerk. De knop gaat niet op disabled: een
      // programmatische form.submit() (spamcontrole) vuurt geen submit-event en blijft dus werken. Een tweede
      // submit stopt hier helemaal (stopImmediatePropagation), anders verstuurt de listener van de spamcontrole
      // hem toch. De time-out houdt het formulier bruikbaar als een controle wordt afgebroken.
      form.addEventListener('submit', function (e) {
        if (form.hasAttribute('data-cu-bezig')) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return;
        }
        form.setAttribute('data-cu-bezig', '');
        function meet() { track('cu_quote_submit', { product: handle, qty: qtyField ? qtyField.value : '' }); }
        if (captchaAan() && !captchaGebonden()) {
          // Spamcontrole nog niet gebonden: of Shopify deze poging weggooit, blijkt pas na alle submit-listeners.
          // Weggegooid (defaultPrevented): geen slot, geen meting, en de laadanimatie van de knop terugzetten.
          window.setTimeout(function () {
            if (e.defaultPrevented) {
              form.removeAttribute('data-cu-bezig');
              Array.prototype.forEach.call(form.querySelectorAll('[aria-busy]'), function (b) { b.removeAttribute('aria-busy'); });
            } else {
              meet();
            }
          }, 0);
        } else {
          meet();
        }
        window.setTimeout(function () { form.removeAttribute('data-cu-bezig'); }, 8000);
      });
      window.addEventListener('pageshow', function () { form.removeAttribute('data-cu-bezig'); });
      if (terug) bindCaptcha();
    }
    if (det.querySelector('[data-cu-quote-posted]')) {
      track('cu_quote_sent', { product: handle });
      // Eén keer meten: herladen, terugkomen of de link delen toont dan geen bevestiging meer maar een leeg formulier.
      try {
        var u = new URL(window.location.href);
        if (u.searchParams.has('contact_posted')) {
          u.searchParams.delete('contact_posted');
          window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
        }
      } catch (e) { /* oude browser: de url blijft zoals hij is */ }
    }
    if (terug) return;
    if (window.location.hash && window.location.hash === '#' + det.id) {
      openQuote(det, false);
      return;
    }
    // Terug van de spamcontrole van Shopify (?form_type=contact&form_key=...): Shopify zet de ingevulde velden terug
    // uit sessionStorage. Dan het formulier open, het teruggezette aantal niet overschrijven en niet als nieuwe
    // opening meten.
    try {
      var sp = new URLSearchParams(window.location.search);
      if (sp.get('form_type') === 'contact' && sp.get('form_key')) {
        if (qtyField) qtyField.setAttribute('data-cu-touched', '');
        gemeten = true;
        openQuote(det, true);
      }
    } catch (x) { /* oude browser: formulier blijft dicht, de velden staan er wel */ }
  }

  function openQuote(det, focus) {
    if (!det) return;
    det.open = true; // de toggle-listener vult het aantal in en meet
    if (det.scrollIntoView) det.scrollIntoView({ block: 'start', behavior: 'smooth' });
    if (focus) {
      var first = det.querySelector('.cu-offerte__paneel input:not([type="hidden"]), .cu-offerte__paneel textarea');
      if (first) {
        window.setTimeout(function () {
          try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
        }, 50);
      }
    }
  }

  function initAge(cb) {
    if (cb.hasAttribute('data-cu-klaar')) return;
    cb.setAttribute('data-cu-klaar', '');
    var attrId = cb.getAttribute('form');
    var form = attrId ? document.getElementById(attrId) : null;
    if (!form || form.tagName !== 'FORM') {
      form = findForm(cb, null); // geen of onjuist form-attribuut: form-id alsnog uit de DOM
      if (formId(form)) cb.setAttribute('form', formId(form));
    }
    guardForm(form);
    var msg = 'Bevestig dat je 18 jaar of ouder bent om dit te bestellen.';
    function set() { cb.setCustomValidity(cb.checked ? '' : msg); }
    cb.addEventListener('change', function () {
      set();
      if (cb.checked) track('cu_age_confirmed');
    });
    cb.addEventListener('invalid', function () { track('cu_age_blocked'); });
    set();
  }

  function initClamp(body) {
    if (body.hasAttribute('data-cu-klaar')) return;
    var btn = document.querySelector('[data-cu-clamp-toggle][aria-controls="' + body.id + '"]');
    if (!btn) return;
    var rem = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;
    var klapRem = parseFloat(body.getAttribute('data-cu-clamp')) || 17; // data-cu-clamp: hoogte in rem
    if (body.classList.contains('cu-inhoud__body--lijst') && window.matchMedia('(max-width: 749px)').matches) klapRem = Math.min(klapRem, 3.3);
    var limit = rem * klapRem;
    if (body.scrollHeight <= limit * 1.2) return; // past bijna: niet inklappen (bij 'load' nog een keer meten)
    body.setAttribute('data-cu-klaar', '');
    body.classList.add('is-collapsed');
    btn.hidden = false;
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = btn.getAttribute('data-more');
    // Een link in het ingeklapte deel die focus krijgt, mag niet onzichtbaar blijven (WCAG 2.4.11).
    body.addEventListener('focusin', function () {
      if (body.classList.contains('is-collapsed')) btn.click();
    });
    btn.addEventListener('click', function () {
      var collapsed = body.classList.toggle('is-collapsed');
      btn.setAttribute('aria-expanded', String(!collapsed));
      btn.textContent = collapsed ? btn.getAttribute('data-more') : btn.getAttribute('data-less');
      if (!collapsed) {
        track('cu_contents_expand');
      } else {
        var kop = body.parentNode && body.parentNode.querySelector('h2');
        if (kop && kop.scrollIntoView) kop.scrollIntoView({ block: 'nearest' });
      }
    });
  }

  function initStop(el) {
    if (el.hasAttribute('data-cu-klaar')) return;
    el.setAttribute('data-cu-klaar', '');
    var stop = el.getAttribute('data-cu-stop');
    if (!stop || todayAms() <= stop) return;
    var sec = sectionOf(el);
    Array.prototype.forEach.call(sec.querySelectorAll('[data-cu-window],[data-cu-deadline]'), function (x) { x.hidden = true; });
    // Ook de leverdatum in het offerteformulier: verborgen en uit, zodat min/max de verzending niet blokkeren.
    Array.prototype.forEach.call(sec.querySelectorAll('[data-cu-quote-date]'), function (d) { d.disabled = true; });
    el.hidden = false;
    var form = findForm(el, el.getAttribute('data-form'));
    if (form) {
      submitters(form).forEach(function (b) {
        b.disabled = true;
        b.setAttribute('aria-disabled', 'true');
      });
    }
    track('cu_season_closed');
  }

  /* Aanvullende livegang-checks in de editor, alleen wat Liquid niet kan zien. Een offerte-app kan de prijs
     later verbergen (asynchroon embed), dus deze checks draaien bij init, bij 'load' en nog twee keer daarna.
     Elke melding komt er hooguit één keer in. */
  function editorLine(list, key, text) {
    if (list.querySelector('[data-cu-js="' + key + '"]')) return;
    var li = document.createElement('li');
    li.setAttribute('data-cu-js', key);
    li.textContent = text;
    list.appendChild(li);
    var sec = list.closest('.shopify-section') || document;
    var status = sec.querySelector('[data-cu-check-status]');
    if (status) {
      var n = list.querySelectorAll('li').length;
      status.textContent = 'Klaar voor livegang: nee, ' + n + (n === 1 ? ' punt' : ' punten') + ' open';
    }
  }

  function editorChecks() {
    if (!(window.Shopify && window.Shopify.designMode)) return;
    var list = document.querySelector('[data-cu-check-list]');
    if (!list) return;
    var sec = list.closest('.shopify-section') || document;
    // Met de btw-schakelaar staat de prijs in .cu-hoofdprijs (de themaprijs is dan bewust verborgen).
    var prijzen = sec.querySelectorAll('.cu-hoofdprijs');
    if (!prijzen.length) {
      var themaprijs = sec.querySelector('.product__price .price') || sec.querySelector('.price');
      prijzen = themaprijs ? [themaprijs] : [];
    }
    var zichtbaar = Array.prototype.some.call(prijzen, function (p) {
      return p.getClientRects().length > 0 && window.getComputedStyle(p).visibility !== 'hidden';
    });
    if (!zichtbaar || document.querySelector('.omgrfq')) {
      editorLine(list, 'prijs', list.getAttribute('data-cu-prijs-melding') || 'Prijs is niet zichtbaar. Niet publiceren.');
    }
    if (document.querySelector('[class*="omgrfq"], [id*="omgrfq"]')) {
      editorLine(list, 'app', 'Offerte-app O:Request a Quote is nog actief op deze pagina. Zet het app-embed uit: het eigen offerteformulier onder de koopknop vervangt de app, anders staan er twee offerteknoppen.');
    }
    if (sec.querySelector('[data-cu-age-needed]') && !sec.querySelector('.product__info input[data-cu-age]')) {
      editorLine(list, 'leeftijd', 'Alcohol: het 18+-vinkje ontbreekt (block cu_leeftijd is weg of staat uit). Koopformulier en sticky balk zijn daarom verborgen. Zet het block terug, boven buy_buttons.');
    }
    if (sec.querySelector('input[data-cu-qty-fallback]')) {
      editorLine(list, 'aantal', 'Aantalveld ontbreekt (aantalkiezer in buy_buttons staat uit of het block is weg). Het minimum gaat nu als verborgen veld mee; zet de aantalkiezer weer aan.');
    }
  }

  /* Template product (losse producten): na een variantkeuze haalt het thema de sectie opnieuw op en publiceert hij
     variantChange met de nieuwe html. Blokken met [data-cu-swap] nemen dan de inhoud uit die html over; het aantalblok
     krijgt de nieuwe prijs per stuk. De sticky balk krijgt bij een excl.-prijs opnieuw de eigen prijs. */
  function initVariantSwap() {
    if (window.cuPdp.swap) return;
    var t = window.theme;
    if (!t || !t.pubsub || typeof t.pubsub.subscribe !== 'function' || !t.pubsub.PUB_SUB_EVENTS) return;
    if (!document.querySelector('[data-cu-swap]')) return;
    window.cuPdp.swap = true;
    t.pubsub.subscribe(t.pubsub.PUB_SUB_EVENTS.variantChange, function (ev) {
      var html = ev && ev.data && ev.data.parsedHTML;
      if (!html || typeof html.querySelector !== 'function') return;
      Array.prototype.forEach.call(document.querySelectorAll('[data-cu-swap]'), function (el) {
        var nieuw = html.querySelector('[data-cu-swap="' + esc(el.getAttribute('data-cu-swap')) + '"]');
        if (!nieuw) return;
        el.innerHTML = nieuw.innerHTML;
        reformatMoney(el);
      });
      Array.prototype.forEach.call(document.querySelectorAll('[data-cu-aantal]'), function (box) {
        var nb = html.querySelector('[data-cu-aantal][data-product-id="' + esc(box.getAttribute('data-product-id') || '') + '"]');
        if (!nb) return;
        box.setAttribute('data-unit', nb.getAttribute('data-unit') || '');
        box.setAttribute('data-excl', nb.getAttribute('data-excl') || '');
        if (typeof box.__cuPrijs === 'function') {
          box.__cuPrijs(parseInt(nb.getAttribute('data-unit'), 10) || 0, parseInt(nb.getAttribute('data-excl'), 10) || 0);
        }
        var sticky = sectionOf(box).querySelector('product-sticky-form') || document.querySelector('product-sticky-form');
        var oud = sticky ? sticky.querySelector('.cu-sticky-prijs') : null;
        if (oud) oud.parentNode.removeChild(oud);
        initSticky(box);
      });
      Array.prototype.forEach.call(document.querySelectorAll('[data-cu-alt-hint]'), function (el) {
        el.hidden = !document.querySelector('.section-cu-alternatieven .card');
      });
    });
  }

  /* Xboost-staffel ('Zakelijk voordeel'): de app zet bij een keuze alleen haar eigen verborgen veld
     (input.xb-upsell-input[name="quantity"]); het aantalveld van het thema bleef op 1, dus de koopknop legde altijd
     1 stuk in de winkelwagen (getest 2026-10-01). Na een klik van de klant in de staffel zet dit het aantalveld op de
     gekozen hoeveelheid. Bij het laden gebeurt niets, zodat de standaardkeuze van de app het aantal niet ongemerkt
     verhoogt. */
  function initXboostSync() {
    if (window.cuPdp.xb) return;
    window.cuPdp.xb = true;
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!e.isTrusted || !t || !t.closest || !t.closest('[class*="xb-"]')) return;
      setTimeout(function () {
        var x = document.querySelector('input.xb-upsell-input[name="quantity"]');
        var n = x ? parseInt(x.value, 10) : 0;
        if (!n || n < 1) return;
        var f = document.querySelector('form[id^="ProductForm-"][data-type="add-to-cart-form"]');
        if (!f) return;
        var q = f.querySelector('input[name="quantity"]:not(.xb-upsell-input)') ||
          document.querySelector('input[name="quantity"][form="' + esc(f.getAttribute('id')) + '"]:not(.xb-upsell-input)');
        if (!q || String(q.value) === String(n)) return;
        q.value = n;
        q.dispatchEvent(new Event('input', { bubbles: true }));
        q.dispatchEvent(new Event('change', { bubbles: true }));
        track('cu_xboost_staffel', { aantal: n });
      }, 80);
    }, true);
  }

  function init(root) {
    root = root && root.querySelectorAll ? root : document;
    initVariantSwap();
    if (document.querySelector('form[id^="ProductForm-"]')) initXboostSync();
    Array.prototype.forEach.call(root.querySelectorAll('input[data-cu-age]'), initAge);
    Array.prototype.forEach.call(root.querySelectorAll('[data-cu-aantal]'), initAantal);
    Array.prototype.forEach.call(root.querySelectorAll('[data-cu-aantal]'), initSticky);
    Array.prototype.forEach.call(root.querySelectorAll('[data-cu-quote-details]'), initQuote);
    // Verwijzing naar het offerteformulier zonder formulier op de pagina (block cu_offerte verborgen): weglaten.
    Array.prototype.forEach.call(document.querySelectorAll('[data-cu-quote-ref]'), function (el) {
      var a = el.querySelector('a[href^="#"]');
      el.hidden = !(a && document.getElementById(a.getAttribute('href').slice(1)));
    });
    syncBtwKnoppen();
    Array.prototype.forEach.call(root.querySelectorAll('[data-cu-clamp]'), initClamp);
    Array.prototype.forEach.call(root.querySelectorAll('[data-cu-stop]'), initStop);
    reformatMoney(root);
    Array.prototype.forEach.call(document.querySelectorAll('[data-cu-alt-hint]'), function (el) {
      el.hidden = !document.querySelector('.section-cu-alternatieven .card');
    });
    editorChecks();
  }

  /* Vangnet voor app-embeds die op de klik van de koopknop zelf naar /cart/add posten: die komen nooit langs
     de submit-guard. In de capture-fase op window, dus vóór elke andere klikhandler; vangt ook de klik die de
     browser bij Enter in het aantalveld maakt. Alleen voor formulieren met de guard en alleen als ze ongeldig zijn. */
  window.addEventListener('click', function (e) {
    var t = e.target;
    var b = t && t.closest ? t.closest('[type="submit"]') : null;
    if (!b || b.disabled) return;
    var f = b.form;
    if (!f || !f.hasAttribute('data-cu-guard') || typeof f.checkValidity !== 'function') return;
    if (!f.checkValidity()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (typeof f.reportValidity === 'function') f.reportValidity();
    }
  }, true);

  document.addEventListener('click', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;
    var knop = el.closest('[data-cu-btw-knop]');
    if (knop) {
      var m = knop.getAttribute('data-cu-btw-knop');
      if (m !== btwMode(null)) {
        setBtwMode(m, true);
        track('cu_btw_toggle', { mode: m });
      }
      return;
    }
    var nieuw = el.closest('a[data-cu-quote-nieuw]');
    if (nieuw) {
      // Na een verzonden aanvraag: zelfde pagina opnieuw laden met een leeg formulier (open via het anker).
      try {
        var nu = new URL(window.location.href);
        var doel = new URL(nieuw.getAttribute('href') || '', window.location.href);
        nu.searchParams.delete('contact_posted');
        if (doel.pathname === nu.pathname) {
          e.preventDefault();
          window.history.replaceState(window.history.state, '', nu.pathname + nu.search + doel.hash);
          window.location.reload();
        }
      } catch (x) { /* dan gewoon de link volgen */ }
      return;
    }
    var open = el.closest('a[data-cu-quote-open]');
    if (open) {
      var det = document.getElementById((open.getAttribute('href') || '').replace(/^#/, ''));
      if (det && det.tagName === 'DETAILS') {
        e.preventDefault();
        openQuote(det, true);
      }
      return;
    }
    var q = el.closest('[data-cu-quote] > a');
    if (q) { track('cu_quote_click', { href: q.getAttribute('href') || '' }); return; }
    var t = el.closest('[data-cu-track]');
    if (t) { track(t.getAttribute('data-cu-track'), { href: t.getAttribute('href') || '' }); return; }
    var link = el.closest('a');
    var grid = link && link.closest('[data-cu-track-links]');
    if (grid) track(grid.getAttribute('data-cu-track-links'), { href: link.getAttribute('href') || '' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  window.addEventListener('load', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cu-clamp]'), initClamp);
    editorChecks();
    if (window.Shopify && window.Shopify.designMode) {
      window.setTimeout(editorChecks, 2000);
      window.setTimeout(editorChecks, 5000);
    }
  });
  // Keuze gewijzigd in een ander tabblad: deze pagina volgt, zonder opnieuw op te slaan.
  window.addEventListener('storage', function (e) {
    if (e && e.key === BTW_KEY && (e.newValue === 'excl' || e.newValue === 'incl') && document.querySelector('[data-cu-btw]')) {
      setBtwMode(e.newValue, false);
    }
  });
  // Terug of vooruit uit de bfcache: het inline script bij de prijs draait dan niet opnieuw en een bevroren
  // pagina krijgt geen storage-event, dus de opgeslagen keuze hier opnieuw lezen.
  window.addEventListener('pageshow', function (e) {
    if (!e || !e.persisted || !document.querySelector('[data-cu-btw]')) return;
    var m = null;
    try { m = window.localStorage.getItem(BTW_KEY); } catch (x) { m = null; }
    if ((m === 'excl' || m === 'incl') && m !== btwMode(null)) setBtwMode(m, false);
  });
  document.addEventListener('page:loaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* v3: contact-pop-up (native dialog; zonder showModal valt het terug op de link naar de contactpagina). */
(function () {
  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('[data-cu-contact-open]');
    if (open) {
      var d = document.getElementById(open.getAttribute('aria-controls'));
      if (d && typeof d.showModal === 'function') { e.preventDefault(); d.showModal(); try { window.Shopify && Shopify.analytics && Shopify.analytics.publish('cu_contact_open', {}); } catch (x) {} }
      return;
    }
    var close = e.target.closest && e.target.closest('[data-cu-contact-close]');
    if (close) { var dc = close.closest('dialog'); if (dc) dc.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('cu-contact')) { e.target.close(); }
  });
})();

/* v4: startaantal (bijvoorbeeld 12 bij pakketten). Het thema zet het aantal bij het laden terug naar het minimum,
   daarom hier nog een keer, nadat het thema klaar is. Alleen als de bezoeker zelf nog niets koos. */
(function () {
  function go() {
    var qs = document.querySelectorAll('input[name="quantity"][data-cu-start]');
    for (var k = 0; k < qs.length; k++) {
      var i = qs[k], d = parseInt(i.defaultValue, 10) || 0;
      if (i.hasAttribute('data-cu-touched')) continue;
      if ((parseInt(i.value, 10) || 0) < d) { i.value = String(d); i.dispatchEvent(new Event('change', { bubbles: true })); }
    }
  }
  document.addEventListener('input', function (e) { if (e.target && e.target.matches && e.target.matches('input[name="quantity"][data-cu-start]') && e.isTrusted) e.target.setAttribute('data-cu-touched', ''); }, true);
  document.addEventListener('click', function (e) { var q = e.target.closest && e.target.closest('quantity-input'); if (q && e.isTrusted) { var i = q.querySelector('input[data-cu-start]'); if (i) i.setAttribute('data-cu-touched', ''); } }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  window.addEventListener('load', go);
})();

/* v6: eigen intro op mobiel na drie regels ingeklapt; 'Lees meer' alleen als de tekst echt langer is. */
(function () {
  function init() {
    var ps = document.querySelectorAll('[data-cu-intro]');
    for (var k = 0; k < ps.length; k++) {
      var p = ps[k], b = p.parentNode.querySelector('[data-cu-intro-toggle]');
      if (!b) continue;
      b.hidden = !(p.scrollHeight > p.clientHeight + 2) || p.classList.contains('is-open');
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cu-intro-toggle]');
    if (!b) return;
    var p = document.getElementById(b.getAttribute('aria-controls'));
    if (!p) return;
    p.classList.add('is-open');
    b.setAttribute('aria-expanded', 'true');
    b.hidden = true;
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish('cu_intro_meer', {}); } catch (x) {}
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('resize', init);
})();

/* 2026-10-01 (groeironde): plakkende koopbalk op mobiel.
   Het thema toont de balk pas als het koopformulier boven het scherm verdwenen is, en alleen na een scroll die het
   formulier passeert (wie landt na een sprong of de terugknop, ziet hem niet). Op mobiel: de balk staat er altijd,
   behalve als het koopformulier zelf of de footer in beeld is. Een tik terwijl het formulier nog komt, scrollt
   naar het koopblok (aantal en minimum in beeld) in plaats van meteen toe te voegen. Desktop blijft zoals het thema
   het doet. Klassen cu-sticky-aan en cu-sticky-uit sturen de zichtbaarheid (zie cu-pdp.css). */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  function init() {
    var sticky = document.querySelector('product-sticky-form');
    if (!sticky) return;
    var form = document.getElementById(sticky.getAttribute('form'));
    var footer = document.querySelector('.footer-group');
    if (!form) return;
    var koop = form.closest('.product__info') ? (form.closest('.buy-buttons') || form) : form;
    var ticking = false;
    function staat() {
      ticking = false;
      if (!mq.matches) { sticky.classList.remove('cu-sticky-aan', 'cu-sticky-uit'); return; }
      var r = koop.getBoundingClientRect();
      var inBeeld = r.bottom > 0 && r.top < window.innerHeight;
      var footerInBeeld = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      var aan = !inBeeld && !footerInBeeld && r.height > 0;
      sticky.classList.toggle('cu-sticky-aan', aan);
      sticky.classList.toggle('cu-sticky-uit', !aan);
      sticky.toggleAttribute('data-cu-voor-koop', aan && r.top >= window.innerHeight);
    }
    function vraag() { if (!ticking) { ticking = true; window.requestAnimationFrame(staat); } }
    window.addEventListener('scroll', vraag, { passive: true });
    window.addEventListener('resize', vraag, { passive: true });
    if (mq.addEventListener) mq.addEventListener('change', vraag);
    sticky.addEventListener('click', function (e) {
      var knop = e.target.closest && e.target.closest('[type="submit"]');
      if (!knop || !mq.matches || koop.getBoundingClientRect().top < window.innerHeight) return;
      e.preventDefault();
      e.stopPropagation();
      koop.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try { window.Shopify && Shopify.analytics && Shopify.analytics.publish('cu_sticky_naar_koop', {}); } catch (x) {}
    }, true);
    staat();
    window.addEventListener('load', staat);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
